module.exports = __webpack_public_path__ + "static/favicon-e3d4be614d9d3666cde992da3be36101.ico";